import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { CustomDomainsSettings } from './settings-custom-domains.component';

export function provideSettingsElementCustomDomains(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'custom-domains',
        name: 'Custom domains',
        icon: 'pi pi-globe',
        component: CustomDomainsSettings,
        // Sits above SMS Gateway (order 1) inside the Integrations category.
        order: 0,
        translateName: 'SETTINGS_CUSTOM_DOMAINS.TITLE',
        resource_key: 'customDomains',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'custom-domains',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'integrations',
          name: 'Integrations',
          order: 2,
          translateName: 'SETTINGS.CATEGORIES.INTEGRATIONS',
        },
      },
      multi: true,
    },
  ]);
}
